import { render, staticRenderFns } from "./ShowProjectInfo.vue?vue&type=template&id=583973d8&scoped=true&"
import script from "./ShowProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ShowProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowProjectInfo.vue?vue&type=style&index=0&id=583973d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583973d8",
  null
  
)

export default component.exports